<p class="govuk-body-s caption" *ngIf="data.lastEdited">Last Updated <span>{{data.lastEdited | date:'d/M/yy, h:mm a'}}</span></p>

<section class="app-prose-scope" tabindex="0" #startText aria-label="Introduction">

  <div *ngIf="data.startText; else defaultStartText" [innerHTML]="data.startText"></div>

  <ng-template #defaultStartText>
    <div>
      <p>Welcome to {{meta.teamName}}’s on-line housing advice service. You can use this service to get advice on the following::</p>

      <ul>
        <li>How to solve problems that are affecting your housing situation</li>
        <li>What to do if you have been asked to leave your property</li>
        <li>How you can find somewhere else to live</li>
        <li>How {{meta.teamName}} may be able to help you</li>
      </ul>

      <p>You will be asked a few short questions to help you find the advice you need, but you don't need to tell us who you are, or where you live.</p>
    </div>
  </ng-template>
</section>

<a routerLink="../questions" role="button" class="govuk-button govuk-button--start govuk-!-margin-top-2 govuk-!-margin-bottom-8 theme-button" #startButton>
  Start
  <svg class="govuk-button__start-icon" xmlns="http://www.w3.org/2000/svg" width="17.5" height="19" viewBox="0 0 33 40" role="presentation" focusable="false">
    <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z" />
  </svg>
</a>
